import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">精彩视频</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 md:h-56 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  width="640"
                  height="360"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-white text-xs font-medium">
                    <i className="ri-play-circle-fill text-lg"></i>
                    {item.duration}
                  </span>
                  <span className="text-white/70 text-xs">{item.views} 次播放</span>
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-white transition-colors">
                  <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}